import clsx from "clsx";
import React from "react";

const LinearBorderContainer = ({ children, className }: { children: React.ReactNode, className?: string }) => {
    return <div
        className={clsx(
            "relative w-full h-full linear-border border-0",
            className
        )}
    >
        <div className="h-[calc(100%-2px)] m-[1px] bg-transparent">
            {children}
        </div>
    </div>;
};

export default LinearBorderContainer;
